import { FDEmptyState, FDList } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';

export const AccordionCategoryListContent = ({
  lineItems,
  onEditLineItemClick,
  ItemComponent,
}) => {
  if (lineItems.length < 1) {
    return (<FDEmptyState
      icon={'search'}
      title={'No items added for this category'}
    />);
  }
  return (
    <FDList>
      {lineItems.map((lineItemResource, idx) => {
        return (
          <ItemComponent
            key={lineItemResource.id()}
            index={idx}
            lineItemResource={lineItemResource}
            onEditClick={onEditLineItemClick}
          />
        );
      })}
    </FDList>
  );
};

AccordionCategoryListContent.propTypes = {
  lineItems: PropTypes.object.isRequired,
  onEditLineItemClick: PropTypes.func.isRequired,
  ItemComponent: PropTypes.func.isRequired,
};
